module.exports = __webpack_public_path__ + "static/media/adaptMi.77ccf11e.png";